import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { PhoneFrame } from './PhoneFrame';
export function LayerCore() {
  return <section className="py-24 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-35">
          <div className="flex items-center gap-3 mb-4" data-id="element-36">
            <div className="bg-solventum-dark text-solventum-green px-4 py-1 rounded-full text-sm font-bold" data-id="element-37">
              LAYER 2
            </div>
            <BookOpen className="w-5 h-5 text-solventum-teal" data-id="element-38" />
            <span className="text-solventum-dark/60 text-xs tracking-[0.2em] uppercase" data-id="element-39">
              Mobile · Player
            </span>
          </div>
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-solventum-dark mb-4" data-id="element-40">
            The Clinical Core
          </h2>
          <p className="text-xl text-solventum-dark/60 max-w-3xl" data-id="element-41">
            The case itself — diagnosis to technique to outcome — formatted for
            the phone. Chapter-aware playback, clinician-narrated. Solventum
            appears naturally where it helped solve the case.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="relative rounded-2xl overflow-hidden ring-1 ring-solventum-gray bg-gradient-to-br from-solventum-lightTeal via-white to-solventum-lightTeal/40 py-16 px-6" data-id="element-42">
          <div className="relative grid lg:grid-cols-[1fr_auto_1fr] gap-10 items-center" data-id="element-43">
            <div className="hidden lg:block space-y-6 text-right" data-id="element-44">
              <FeatureRow title="Clinician-narrated" body="Voice and frame stay with the clinician — credibility intact." tone="light" data-id="element-45" />
              <FeatureRow title="Product in service" body="Solventum moments are surfaced as captions, never as ads." tone="light" data-id="element-46" />
            </div>

            <PhoneFrame data-id="element-47">
              <ClinicalCoreScreen data-id="element-48" />
            </PhoneFrame>

            <div className="hidden lg:block space-y-6" data-id="element-49">
              <FeatureRow title="Chapter map" body="Practitioners can skip straight to layering or finishing." align="left" tone="light" data-id="element-50" />
              <FeatureRow title="Diagnosis → outcome" body="The full clinical arc, from first photo to final polish." align="left" tone="light" data-id="element-51" />
              <FeatureRow title="Adapts to content" body="From video to clinical images and text — easy to scale and reuse across available content." align="left" tone="light" data-id="element-52" />
            </div>
          </div>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center text-solventum-dark/60 mt-12 italic" data-id="element-53">
          The clinician tells the story. The product is in service of the case.
        </motion.p>
      </div>
    </section>;
}
function FeatureRow({
  title,
  body,
  align = 'right',
  tone = 'dark'
}: {
  title: string;
  body: string;
  align?: 'left' | 'right';
  tone?: 'light' | 'dark';
}) {
  const titleColor = tone === 'light' ? 'text-solventum-teal' : 'text-solventum-green';
  const bodyColor = tone === 'light' ? 'text-solventum-dark/70' : 'text-solventum-lightTeal/70';
  return <div className={align === 'right' ? 'ml-auto max-w-[240px]' : 'max-w-[240px]'} data-id="element-54">
      <div className={`${titleColor} text-[10px] font-semibold tracking-[0.25em] uppercase mb-2`} data-id="element-55">
        {title}
      </div>
      <div className={`${bodyColor} text-sm leading-relaxed`} data-id="element-56">{body}</div>
    </div>;
}
function ClinicalCoreScreen() {
  return <div className="relative w-full h-full bg-solventum-dark overflow-hidden" data-id="element-57">
      <img src="https://cdn.magicpatterns.com/uploads/gT69geP7mGTG7NzXPC3uND/Screenshot_2026-05-19_at_13.40.59.png" alt="Clinical core — chapter 7, isolation & prep" className="absolute inset-0 w-full h-full object-contain object-top" data-id="element-58" />
    </div>;
}